import selectLocalExercise from './selectLocalExercise';
const selectLostXp = (state, exerciseId) => {
  const localExercise = selectLocalExercise(state, exerciseId);
  if (localExercise === undefined) {
    return 0;
  }
  return localExercise.lostXp;
};
export default selectLostXp;